var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleCancelledVoiceCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0892 1.91058C17.7637 1.58514 17.2361 1.58514 16.9107 1.91058L14.1666 4.65466V3.33317C14.1666 2.87293 13.7935 2.49984 13.3333 2.49984C12.873 2.49984 12.4999 2.87293 12.4999 3.33317V6.6665C12.4999 7.12674 12.873 7.49984 13.3333 7.49984H16.6666C17.1268 7.49984 17.4999 7.12674 17.4999 6.6665C17.4999 6.20627 17.1268 5.83317 16.6666 5.83317H15.3451L18.0892 3.08909C18.4146 2.76366 18.4146 2.23602 18.0892 1.91058Z",
    fill: "#FF3A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43129 2.49984C2.74225 2.49984 2.08143 2.77356 1.5942 3.26079C1.10697 3.74801 0.833252 4.40883 0.833252 5.09788C0.833252 5.11474 0.833764 5.1316 0.834786 5.14843C1.05629 8.79341 2.60415 12.2313 5.1863 14.8135C7.76845 17.3956 11.2063 18.9435 14.8513 19.165C14.8682 19.166 14.885 19.1665 14.9019 19.1665C15.5909 19.1665 16.2517 18.8928 16.739 18.4056C17.2262 17.9183 17.4999 17.2575 17.4999 16.5685V14.1674C17.4999 13.1452 16.8775 12.2259 15.9284 11.8462L13.7118 10.9596C12.6707 10.5432 11.4813 10.9439 10.9044 11.9054C10.7212 12.2107 10.4113 12.2318 10.2447 12.1188C9.31421 11.4878 8.51193 10.6856 7.88096 9.75508C7.76799 9.58849 7.78909 9.27855 8.09435 9.09539C9.05588 8.51848 9.45657 7.32903 9.04013 6.28791L8.15351 4.07136C7.77385 3.12221 6.85458 2.49984 5.83231 2.49984H3.43129Z",
    fill: "#FF3A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleCancelledVoiceCall);
export default __webpack_public_path__ + "static/media/people-cancelled-voice-call.4b012d831ac4ab182e9dda89d8b5798d.svg";
export { ForwardRef as ReactComponent };